<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                LC Import Document Records
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    />
                  </v-col>

                  <v-col md="5" cols="12">
                    <!-- Export buttons (CSV/Excel/PDF) can be added here if needed -->
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="text-right pr-2">
                      <v-btn
                        v-if="$insertAccess($route.fullPath)"
                        color="primary"
                        variant="tonal"
                        prepend-icon="mdi-plus"
                        rounded="xl"
                        @click="$router.push({ name: 'lc-import-document-create' })"
                      >
                        Add Document
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="documents"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  density="compact"
                  :hover="true"
                >
                  <template #item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template #item.document_type="{ item }">
                    {{ item.document_type?.name || item.documentType?.name || "" }}
                  </template>

                  <template #item.status="{ item }">
                    <v-chip size="small" :color="item.status == 1 ? 'success' : 'red'">
                      {{ item.status == 1 ? "Active" : "Inactive" }}
                    </v-chip>
                  </template>

                  <template #item.actions="{ item }">
                    <v-icon
                      class="me-2 edit-button"
                      color="primary"
                      v-if="$updateAccess($route.fullPath)"
                      @click="$router.push({ name: 'lc-import-document-edit', params: { id: item.id } })"
                      title="Edit"
                    >
                      mdi-pencil-outline
                    </v-icon>

                    <v-icon
                      color="green"
                      class="ml-1"
                      title="View"
                      @click="viewFile(item)"
                    >
                      mdi-file-eye
                    </v-icon>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { fileServerUrl } from "@/store/api";

export default {
  name: "LcImportDocumentRecord",
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    headers: [
      { title: "#SL", key: "index", align: "center", sortable: false, width: "6%" },
      { title: "Code", key: "code", align: "left" },
      { title: "LC No.", key: "lc_master.lc_no", align: "left" },
      { title: "Document Type", key: "document_type", align: "left" },
      { title: "Document No", key: "document_no", align: "left" },
      { title: "Date", key: "document_date", align: "left" },
      { title: "Remarks", key: "remarks", align: "left" },
      { title: "Status", key: "status", align: "center" },
      { title: "Actions", key: "actions", align: "center", sortable: false },
    ],
  }),
  computed: {
    documents() {
      return this.$store.getters["lcImportDocument/getLcImportDocumentList"] || [];
    },
  },
  created() {
    this.loading = true;
    this.$store
      .dispatch("lcImportDocument/getLcImportDocumentList")
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    viewFile(item) {
      if (!item.file_path) return;
      const url = fileServerUrl + item.file_path;
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
.edit-button {
  cursor: pointer;
}
.edit-button:hover {
  transform: scale(1.2);
}
</style>

